import alt from '../alt';

class userAction {
    constructor() {
        this.generateActions(
            'warningMsg',
            'processing',
            'resetPasswordSuccess',
            'changePasswordSuccess',
            'resetFgPasswordSuccess',
            'isfgPwdSend',
            'userLoginSuccess',
            'userLoginFail',
            'logout',
        );
    }
    isUserLogin() {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/isUserLogin', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.userLoginSuccess(result);
                    } else if (xhttp.status == 400) {
                        //handle Error
                        this.warningMsg(result.errorMsg);
                        this.userLoginFail();
                    }
                }
            };
            xhttp.send(null);
        }
        /*
             
       //simulate data
       this.userLoginSuccess({
           token: "abc",
           role: 0,
           staffId: "A0011d",
           userName: "Ho Kok Liang",
           userImage: "testing",
       });
        */
        return true;
    }
    userLogin(staffId, pw) {

        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", '/v1/api/userLogin', true);
        xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4) {
                let result = JSON.parse(xhttp.responseText);
                if (xhttp.status == 200) {
                    this.userLoginSuccess(result);
                } else if (xhttp.status == 400) {
                    //handle Error
                    this.warningMsg(result.errorMsg);
                    this.userLoginFail();
                }
                this.processing(false);
            }
        };
        xhttp.send(JSON.stringify({
            staffId: staffId,
            password: pw
        }));

        /*
        //simulate login success
        this.userLoginSuccess({
            token: "abc",
            role: 0,
            staffId: "A0011d",
            userName: "Ho Kok Liang",
            userImage: "testing",
        });
        this.processing(false);
        */
        return true;
    }
    forgotPassword(email) {
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", '/v1/api/forgotPassword', true);
        xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4) {
                if (xhttp.status == 200) {
                    this.warningMsg("An email has sent to your emailbox. You will redirect to homepage in 3 second");
                    this.isfgPwdSend(true);
                } else if (xhttp.status == 400) {
                    //handle Error
                    let result = JSON.parse(xhttp.responseText);
                    this.warningMsg(result.errorMsg);
                }
                this.processing(false);
            }
        };
        xhttp.send(JSON.stringify({ email: email }));

        return true;
    }
    resetFgPassword(token, password) {
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", '/v1/api/forgotPassword/' + token, true);
        xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4) {
                if (xhttp.status == 200) {
                    this.warningMsg("Pasword reset successfully");
                    this.resetFgPasswordSuccess();
                } else if (xhttp.status == 400) {
                    //handle Error
                    let result = JSON.parse(xhttp.responseText);
                    this.warningMsg(result.errorMsg);
                }
                this.processing(false);
            }
        };
        xhttp.send(JSON.stringify({
            password: password
        }));

        return true;
    }

    resetPassword(token, password) {
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", '/v1/api/resetPassword', true);
        xhttp.setRequestHeader("Authorization", "Bearer " + token);
        xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4) {

                if (xhttp.status == 200) {
                    this.warningMsg("Pasword reset successfully");
                    this.resetPasswordSuccess(token);
                } else if (xhttp.status == 400) {
                    //handle Error
                    let result = JSON.parse(xhttp.responseText);
                    this.warningMsg(result.errorMsg);
                }
                this.processing(false);
            }
        };
        xhttp.send(JSON.stringify({
            password: password
        }));

        return true;
    }
    changePassword(currentPassword, newPassword) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/changePassword', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {

                    if (xhttp.status == 200) {
                        this.warningMsg("Password Changed. You will redicrect to home page in 3 seconds");
                        setTimeout(() => {
                            this.changePasswordSuccess();
                        }, 3000);
                    } else if (xhttp.status == 400) {
                        //handle Error
                        let result = JSON.parse(xhttp.responseText);
                        this.warningMsg(result.errorMsg);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                currentPassword: currentPassword,
                newPassword: newPassword
            }));
        }
        return true;
    }
}

export default alt.createActions(userAction);


// WEBPACK FOOTER //
// ./app/actions/userAction.js